export default "__VITE_ASSET__76b7a218__"